import { useDebouncedValue } from "@mantine/hooks";
import { useState } from "react";

export const useDebouncedState = <T>(inputValue: T) => {
  const [value, setValue] = useState(inputValue);
  const [debouncedValue] = useDebouncedValue(value, 200);

  return [debouncedValue, value, setValue] as const;
};
